
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { mesAutobind, context } from '@posco/posco-shared';
import { ContentLayout, Popout } from '@posco/posco-ui-react';

import ItemListView from '../view/ItemListView';
import SnapChartView from '../view/SnapChartView';


@inject('itemStore', 'itemsUiStore')
@mesAutobind
@observer
class ItemListContainer extends Component {
  //
  componentDidMount() {
    this.findAllItems();
    this.props.itemsUiStore.setDataType(ChartExampleSnap.DATA_TYPE.first);
  }

  componentWillUnmount() {
    this.props.itemStore.clearItems();
    this.props.itemsUiStore.clear();
  }

  findAllItems() {
    this.props.itemStore.findAllItems();
  }

  handleToggleChartDataType() {
    //
    const { itemsUiStore } = this.props;
    const { DATA_TYPE } = ChartExampleSnap;
    const nextDataType = itemsUiStore.dataType === DATA_TYPE.first ? DATA_TYPE.second : DATA_TYPE.first;

    itemsUiStore.setDataType(nextDataType);
  }

  handleClickItemWindow(e, { itemNo }) {
    //
    const { itemsUiStore } = this.props;

    itemsUiStore.setItemNo(itemNo);
    itemsUiStore.setPopOpen(true);
  }

  handleConfirmPopout(data) {
    console.log('[ItemListContainer] From Popout data:', data);
  }

  handleClosePopout() {
    //
    const { itemsUiStore } = this.props;

    itemsUiStore.setPopOpen(false);
    itemsUiStore.setItemNo(null);
    console.log('[ItemListContainer] Close Popout');
  }

  render() {
    //
    const {
      itemStore, itemsUiStore,
    } = this.props;

    return (
      <ContentLayout>
        <ContentLayout.Header
          title="Item List"
        />

        <Popout
          title="Pop"
          open={itemsUiStore.popOpen}
          url={`${context.path()}/items/${itemsUiStore.itemNo}?layout=hidden`}
          options={{ toolbars: 'no', location: 'no', width: 800, height: 500 }}
          onConfirm={this.handleConfirmPopout}
          onClose={this.handleClosePopout}
        />

        <ItemListView
          items={itemStore.items}
          onClickItemWindow={this.handleClickItemWindow}
        />

        <SnapChartView
          onChangeDataType={this.handleToggleChartDataType}
        >
          <ChartExampleSnap
            dataType={itemsUiStore.dataType}
          />
        </SnapChartView>
      </ContentLayout>
    );
  }
}

export default ItemListContainer;
